import * as React from 'react';
import MainLayout from "./app/Layout";
import GlobalProvider from "./state/GlobalProvider";
import { ThemeProvider } from "./components/theme-provider";
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";

loadDevMessages();
loadErrorMessages();

function App() {
  return (
      <GlobalProvider>
          <ThemeProvider defaultTheme="system" storageKey="vonix-integration-theme">
              <MainLayout />
          </ThemeProvider>
      </GlobalProvider>
  )
}

export default App;
